<style>
body {
  
}

  .subheading {
    text-align: center;
  }

  .article {
    width: 90%;
    margin: 0 auto;
    padding: 8px;
    color: rgba(33, 33, 33, 1);
    font-family: Lato, sans-serif;
    font-size: 15px;
    font-weight: 400;
    line-height: 1.6667;
  }

  .home {
    margin-top: -48px;
    
  }
  .v-content{
    background-color: Black;
  }

  .notranslate {
    border-radius: 5px;
    border: 2px solid #696969;
    box-shadow:-10px 0 10px #696969;
  }

</style>
<template>
  <v-app v-scroll="onScroll">
    <v-navigation-drawer 
      temporary
      app
      dark
      v-show="!noAppShell"
      v-model="drawer">
      <v-list dense>
        <v-list-item link @click="drawer = false">
          <v-list-item-action>
            <v-icon>mdi-close</v-icon>
          </v-list-item-action>
        </v-list-item>
        <v-list-item :to="mainPath">
          <v-list-item-content>
            <v-list-item-title>Main</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/termsOfService">
          <v-list-item-content>
            <v-list-item-title>Terms of Service</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/privacyPolicy">
          <v-list-item-content>
            <v-list-item-title>Privacy Policy</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app v-show="!noAppShell" :color="headerColor" dark dense elevate-on-scroll>
      <v-app-bar-nav-icon class="hidden-md-and-up" @click="drawer = true"></v-app-bar-nav-icon>
      <v-toolbar-title></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn class="hidden-sm-and-down" text :to="mainPath">
        <span>Main</span>
      </v-btn>
      <v-btn class="hidden-sm-and-down" text to="/termsOfService">
        <span>Terms of Service</span>
      </v-btn>
      <v-btn class="hidden-sm-and-down" text to="/privacyPolicy">
        <span>Privacy Policy</span>
      </v-btn>
    </v-app-bar>
    <v-content>
      <router-view></router-view>
    </v-content>
    <v-footer color="primary lighten-1" padless v-if="showFooter">
      <v-layout justify-center wrap>
        <v-btn v-for="link in links" :key="`${link.label}-footer-link`" color="white" text rounded class="my-2"
          :to="link.url">
          {{ link.label }}
        </v-btn>
        <v-flex primary lighten-2 py-4 text-center white--text xs12>
          {{ new Date().getFullYear() }} — <strong>Vuetify Dashboard</strong>
        </v-flex>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
        drawer: false,
        links: [{
            label: 'Main',
            url: '/MobileHome'
          },
          {
            label: 'termsOfService',
            url: '/termsOfService'
          },
          {
            label: 'privacyPolicy',
            url: '/privacyPolicy'
          }
        ],
        showFooter: false,
        headerColor: 'transparent',
        routerPath: '',
        urlPath: '',
        mainPath: '/',
        noAppShell: false
      }
    },
    watch:{
      // $route(to,from){
      //   // eslint-disable-next-line no-console
      //   //console.log(to.path);
      //   if (to.path.indexOf('articleItem') > -1 || to.path.indexOf('spreadTrack') > -1 || to.path.indexOf('landpage') > -1 ) {
      //     this.noAppShell = true
      //   } else {
      //     this.noAppShell = false
      //   }
      //   // eslint-disable-next-line no-console
      //   //console.log(from.path);
      // }
    },
    // mounted(){
    //   this.urlPath=window.location.href.split("/");
    //   if(this.urlPath[3] == 'termsOfService' ){
    //     this.$router.replace('/termsOfService');
    //   }else if(this.urlPath[3] == 'privacyPolicy'){
    //     this.$router.replace('/privacyPolicy');
    //   }else{
    //     if (this.isMobile()) {
    //       this.mainPath='/MobileHome';
    //       this.$router.replace('/MobileHome');
    //     } else {
    //       this.mainPath = '/';
    //       this.$router.replace('/');
    //     }
    //   }     
    // },
    methods: {
      toggleTheme() {
        this.$vuetify.theme.themes.dark.anchor = '#41B883'
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark
      },
      isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
      },
      onScroll() {
        let scrollTop = this.getScrollTop()
        // eslint-disable-next-line no-console
        if (scrollTop ===  0) {
          this.headerColor = 'transparent'
        } else {
          this.headerColor = '#212121'
        }
      },
      getScrollTop() {
        var scrollPos;
        if (window.pageYOffset) {
          scrollPos = window.pageYOffset;
        } else if (document.compatMode && document.compatMode != 'BackCompat') {
          scrollPos = document.documentElement.scrollTop;
        } else if (document.body) {
          scrollPos = document.body.scrollTop;
        }
        return scrollPos;
      },
      created() {
        this.routerPath = this.$route.path
        // eslint-disable-next-line no-console
        console.log('routerPath' + this.routerPath)
      }
    }
  }
</script>